import * as MODULES from '../module-codes'
import axios from 'axios'
import Mustache from 'mustache'

export const state = () => ({
  currentThread: 0,
  emails: [],
  sentEmails: [],
  watchedRecipients: [],
  emailActions: 0, // Used for reactivity in LeftMenu.vue
})

export const getters = {
  unreadEmails: state => {
    return state.emails.reduce((total, email) => {
      return total + (email.read ? 0 : 1)
    }, 0)
  },
  processedEmails: (state, getters, rootState) => {
    return state.emails.sort(
        (b, a) => new Date(a.date).getTime() - new Date(b.date).getTime()
      ).map(email => {
      let templatedEmail = { ...email }
      let context = { role: rootState.roles.role || { name: 'unset' }, ...rootState }
      templatedEmail['body'] = Mustache.render(email.body, context)
      if (email.to) {
        templatedEmail['to'] = Mustache.render(email.to, context)
      }
      return templatedEmail;
    }) || []
  },
}

// dispatch
// sync or async
// do not modify state
// camel-case
// for business logic
export const actions = {
  addWatchedRecipient: ({commit, dispatch}, content) => {
    commit('ADD_WATCHED_RECIPIENT', content)
    dispatch('saveState')
  },
  addSentEmail: ({ state, commit, dispatch }, content) => {
    try {
      commit('ADD_SENT_EMAIL', content)
      let watchedRecipient = state.watchedRecipients.find((item) => {
        return item.recipient === content.to
      })
      if (watchedRecipient) {
        dispatch("events/processEvent", { eventId: watchedRecipient.event_id }, { root: true });
        commit('REMOVE_WATCHED_RECIPIENT', watchedRecipient)
      }
      dispatch('saveState')
    } catch (err) {
      axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  newEmail: function({ state, commit, dispatch }, newEmail) {
    try {
      newEmail.thread_id = state.currentThread
      newEmail.date = new Date()
      commit('NEW_EMAIL', newEmail)
      if (!newEmail.isReply) {
        commit('NEXT_THREAD')
      }
      dispatch('saveState')
    } catch (err) {
      axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  readEmail: ({ commit, dispatch }, eventId) => {
    commit('READ_EMAIL', eventId)
    dispatch('saveState')
  },
  saveState: async function ({ state, rootState }) {
    try {
      await axios.post('/api/updateModule', {
        params: {
          moduleState: state,
          moduleName: MODULES.EMAIL,
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      })
    } catch (err) {
      await axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  populateFromDB: async ({ commit, dispatch, state }, payload) => {
    if (payload) {
      commit('POPULATE_MODULE', payload)
    }
  },
}

// commit
// synchronous
// may modify state
// all-caps
// look like getters/setters
export const mutations = {
  ADD_WATCHED_RECIPIENT: (state, payload) => {
    let data = {
      recipient: payload.recipient,
      event_id: payload.event_id
    }
    state.watchedRecipients.push(data)
  },
  REMOVE_WATCHED_RECIPIENT: (state, watchedRecipient) => {
    let index = state.watchedRecipients.indexOf(watchedRecipient)
    if (index !== -1) {
      state.watchedRecipients.splice(index, 1)
    }
  },
  ADD_SENT_EMAIL: (state, email) => {
    state.sentEmails.push(email)
    state.emailActions++
  },
  NEW_EMAIL: (state, newEmail) => {
    // add a new email
    state.emails.push(newEmail)
    // if (!newEmail.isReply) {
    //   state.currentThread++
    // }
    state.emailActions++
  },
  NEXT_THREAD: state => {
    state.currentThread++
  },
  POPULATE_MODULE: (state, newState) => {
    // pulled from user_has_module_content table
    state.currentThread = newState.currentThread
    state.emails = newState.emails
    state.sentEmails = newState.sentEmails
    state.watchedRecipients = newState.watchedRecipients
  },
  READ_EMAIL: (state, eventId) => {
    // The email with event_id is now read
    for (let i = 0; i < state.emails.length; i++) {
      if (state.emails[i].event_id === eventId) {
        state.emails[i].read = true
      }
    }
    state.emailActions++
  },
  CLEAR_STATE: state => {
    state.emails = []
    state.sentEmails = []
    state.watchedRecipients = []
  },
}
